import * as React from "react";
import { useSearch, StatsProps } from "@usereactify/search";

export type ExampleStatsProps = React.ComponentProps<
    NonNullable<StatsProps["render"]>
>;

export const SearchResultsStats: React.FC<ExampleStatsProps> = (props) => {
    const searchHook = useSearch();
    return (
        <h2 className={`search-results__summary h3`}>
            SHOWING {props?.resultStats?.numberOfResults} RESULTS FOR "{searchHook.searchTerm}"
        </h2>
    );
};

export default SearchResultsStats;
